module.exports = __webpack_public_path__ + "img/IMG_0346.abca3d67.jpg";